var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"reportView",rawName:"v-reportView:load",value:({ pageload: 1, pagetype: 1 }),expression:"{ pageload: 1, pagetype: 1 }",arg:"load"}],staticClass:"home"},[_c('ConvertList'),_c('Advantage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }